import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AdaptiveSizes;
export var PARAM_FIELD_SIZE = 'size';
export var AdaptiveSizeNames = /*#__PURE__*/function (AdaptiveSizeNames) {
  AdaptiveSizeNames["GLOBAL"] = "_";
  AdaptiveSizeNames["XXXL"] = "xxxl";
  AdaptiveSizeNames["XXL"] = "xxl";
  AdaptiveSizeNames["XL"] = "xl";
  AdaptiveSizeNames["L"] = "l";
  AdaptiveSizeNames["M"] = "m";
  AdaptiveSizeNames["S"] = "s";
  AdaptiveSizeNames["XS"] = "xs";
  AdaptiveSizeNames["XXS"] = "xxs";
  AdaptiveSizeNames["XXXS"] = "xxxs";
  return AdaptiveSizeNames;
}({});
export var AdaptiveSizes = (_AdaptiveSizes = {}, _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.GLOBAL, Infinity), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.XXXL, 1920), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.XXL, 1600), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.XL, 1280), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.L, 1004), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.M, 800), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.S, 640), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.XS, 502), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.XXS, 400), _defineProperty(_AdaptiveSizes, AdaptiveSizeNames.XXXS, 320), _AdaptiveSizes);